import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { useTheme } from "../context/ThemeContext";

export default function ServiceDetail() {
  const { slug } = useParams();
  const t = useTheme();
  const [s, setS] = useState(null);
  useEffect(() => { api.get(`/catalog/services/${slug}`).then(r => setS(r.data)).catch(() => setS(null)); }, [slug]);
  if (!s) return <div className="max-w-5xl mx-auto px-6 py-24" data-testid="service-detail-loading">Loading…</div>;
  const hero = s.category === 'mens'
    ? "https://images.unsplash.com/photo-1619233543640-af09c173763b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800"
    : "https://images.unsplash.com/photo-1599332069800-fcf11ed035ff?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800";
  return (
    <div data-testid="service-detail">
      <section className="relative h-[60vh] w-full overflow-hidden">
        <img src={hero} alt={s.name} className="absolute inset-0 w-full h-full object-cover grayscale" />
        <div className="absolute inset-0 bg-black/55" />
        <div className="relative z-10 h-full max-w-7xl mx-auto px-6 lg:px-8 flex flex-col justify-end pb-16 text-white">
          <div className="text-[11px] tracking-[0.4em] uppercase opacity-80">{s.category === 'mens' ? "Men's Studio" : "Women's Hair"}</div>
          <h1 className="mt-3 text-5xl sm:text-7xl" style={{ fontFamily: t.location === 'ocala' ? "'Cormorant Garamond', serif" : "'Archivo', sans-serif", fontWeight: t.location === 'ocala' ? 400 : 800 }}>{s.name}</h1>
        </div>
      </section>
      <section className="max-w-5xl mx-auto px-6 lg:px-8 py-20 grid md:grid-cols-3 gap-12">
        <div className="md:col-span-2">
          <p className="text-lg leading-relaxed opacity-85">{s.description}</p>
          <div className="mt-10">
            <div className="text-xs tracking-[0.3em] uppercase" style={{ color: t.primary }}>What's Included</div>
            <ul className="mt-4 space-y-2 opacity-85">{s.included.map(i => <li key={i}>— {i}</li>)}</ul>
          </div>
        </div>
        <aside className={`p-8 bg-white border ${t.accentBorder}`} style={{ borderBottom: t.location === 'miami' ? `3px solid ${t.primary}` : undefined }}>
          <div className="text-xs tracking-[0.3em] uppercase opacity-70">Price</div>
          <div className="mt-1 text-4xl" style={{ color: t.primary }}>{s.price_label || `$${s.price}`}</div>
          <div className="mt-6 text-xs tracking-[0.3em] uppercase opacity-70">Duration</div>
          <div className="mt-1 text-xl">{s.duration}</div>
          <Link to={`/booking?service=${s.slug}`} className={`mt-8 block text-center px-6 py-4 text-xs tracking-[0.3em] uppercase ${t.btnPrimary}`} data-testid="service-detail-book">Book This Service</Link>
        </aside>
      </section>
    </div>
  );
}
